export default {"src":"/_next/static/media/baby8.c8a86e68.svg","height":210,"width":210,"blurWidth":0,"blurHeight":0};